import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  applied_job_details_mentor_action,
  get_applied_jobs_list_mentor_action,
} from "../../../redux/_actions";

function useViewAppliedJobExtended(props) {
  const [allJobs, setallJobs] = useState({});
  const [jobDetails, setjobDetails] = useState({});
  const [loading, setloading] = useState(false);
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(null);
  const [jobId, setJobId] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const jobCardDivParentRef = useRef(null);
  const navigate = useNavigate();

  const { appliedJobsListData } = useSelector(
    (state) => state.get_applied_jobs_list_mentor_reducer
  );

  const { appliedJobDetailsData } = useSelector(
    (state) => state.get_applied_job_details_mentor_reducer
  );

  //get page number
  useEffect(() => {
    const index = location?.state && location.state?.index;
    if (index) {
      let pageNum = Math.floor(index / 10) + 1;
      setCurrentPage(pageNum);
    } else {
      setCurrentPage(1);
    }
  }, []);

  useEffect(() => {
    if (currentPage !== null) {
      callApi();
    }
  }, [currentPage]);

  //get current job or job on zero number
  useEffect(() => {
    const job_id = location?.state && location.state?.job_id;
    if (job_id) {
      onCurrentJobCardChange(job_id);
      setJobId(job_id);
    } else if (jobId === null) {
      if (appliedJobsListData?.data) {
        if (
          appliedJobsListData.data?.results &&
          Array.isArray(appliedJobsListData.data?.results) &&
          appliedJobsListData.data?.results.length > 0
        ) {
          let id = appliedJobsListData.data?.results[0].job_posting;
          onCurrentJobCardChange(id);
        }
      }
    }
  }, [appliedJobsListData, jobId]);

  useEffect(() => {
    if (appliedJobsListData?.data) {
      setallJobs(appliedJobsListData?.data);
    }
  }, [appliedJobsListData]);

  //job details
  useEffect(() => {
    if (appliedJobDetailsData?.data !== undefined) {
      setjobDetails(appliedJobDetailsData?.data);
    }
  }, [appliedJobDetailsData]);

  const callApi = async () => {
    setloading(true);
    await dispatch(get_applied_jobs_list_mentor_action(currentPage));
    setloading(false);
  };

  const onCurrentJobCardChange = async (id) => {
    setJobDetailsLoading(true);
    await dispatch(applied_job_details_mentor_action(id));
    setJobDetailsLoading(false);
  };

  const onCurrentPageChange = (page) => {
    setCurrentPage(page);
    setJobId(null);
  };

  const onViewCompany = (id) => {
    navigate(`/company-info/${id}`, {
      state: {
        companyId: id,
      },
    });
  };
  return {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    currentPage,
    jobCardDivParentRef,
    onViewCompany,

    onCurrentJobCardChange,
    onCurrentPageChange,
  };
}
export default useViewAppliedJobExtended;
